import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import CreateTemplate from './createTemplate';
import EditTemplate from './editTemplate';
import { AgGridReact } from 'ag-grid-react';
import { toast } from 'react-toastify';
import apiServices from '../../../services/service';
import { NameFormatter } from '../../../shared/controls/formatters';
import { getAllTemplate } from '../../../redux/selector';
import { fetchDataAndUpdateStore } from '../../../redux/actions';
import { isLoadingByKey } from '../../../shared/controls/methods/getLoadingState';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../shared/component/Loader';
import CustomLoadingOverlay from '../../../shared/component/customLoadingOverlay';
import DeleteConfirmationModal from '../../../shared/modal/deleteConfirmation';

const OptionButton = ({ paramsValue, rowData, handleClickDelete }) => {
  const [showConfirmation, setShowConfirmation] = React.useState(false);

  const handleDeleteClick = () => {
    setShowConfirmation(true);
  };

  const handleConfirmDelete = () => {
    handleClickDelete(paramsValue);
    setShowConfirmation(false);
  };

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
  };

  return (
    <div className="action-menu">
      <img
        src="/assets/images/trash.png"
        className="action-img2"
        onClick={handleDeleteClick}
        alt="Delete Account"
        title="Delete Account"
      ></img>
      <DeleteConfirmationModal
        show={showConfirmation}
        handleClose={handleCloseConfirmation}
        handleConfirm={handleConfirmDelete}
        rowData={rowData}
        content={'template'}
      />
    </div>
  );
};

const Templates = ({ details }) => {
  let title = details?.title;
  let description = details?.description;

  const [activeDropdown, setActiveDropdown] = useState(null);
  const stateData = useSelector((state) => state);
  let storeLoading = isLoadingByKey(stateData, 'template');
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(storeLoading);
  const [selectedTheme, setSelectedTheme] = useState('balham');
  const dropdownRef = useRef(null);
  const gridRef = useRef();
  // const rowData = useFetchIfNeeded(getAllTemplate, fetchDataAndUpdateStore, {
  //   key: "template",
  // });

  const [rowData, setRowData] = useState(null);
  const [deleteData, setDeleteData] = useState(null);

  const templateData = useSelector(getAllTemplate); // assuming it returns an array or null

  useEffect(() => {
    if (templateData === null) {
      dispatch(fetchDataAndUpdateStore({ key: 'template' }));
    } else {
      setRowData(templateData);
    }
  }, [templateData]);

  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const groupByTemplateType = (data) => {
    return Object.entries(
      data?.reduce((acc, item) => {
        if (!acc[item.templateType]) {
          acc[item.templateType] = [];
        }
        acc[item.templateType].push(item);
        return acc;
      }, {})
    ).map(([templateType, items]) => ({ templateType, items }));
  };

  const groupedData = groupByTemplateType(rowData || []);
  console.log('test', groupedData);

  const location = useLocation();

  const toggleDropdown = (id) => {
    setActiveDropdown((prevId) => (prevId === id ? null : id));
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setActiveDropdown(null);
    }
  };

  useEffect(() => {
    setLoading(storeLoading);
  }, [storeLoading]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const [showTemplatePopup, setShowTemplatePopup] = useState(false);
  const [templatePageType, setTemplatePageType] = useState();
  const [searchTerm, setSearchTerm] = useState('');

  const templatePopup = (val) => {
    setTemplatePageType(val);
    setShowTemplatePopup(true);
  };

  const closeTemplatePopup = () => {
    setShowTemplatePopup(false);
  };

  const [showEditTemplatePopup, setEditTemplatePopup] = useState(false);
  const editTemplatePopup = () => {
    setEditTemplatePopup(true);
  };

  const closeEditTemplatePopup = () => {
    setEditTemplatePopup(false);
  };

  const onFilterTextBoxChanged = useCallback(() => {
    gridRef.current.api.setQuickFilter(document.getElementById('filter-text-box').value);
  }, []);

  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: 'Actions',
      cellRenderer: (params) => {
        const paramsValue = { ...params.data };
        return (
          <OptionButton
            rowData={paramsValue}
            handleClickDelete={() => handleClickDelete(paramsValue)}
          />
        );
      },
      maxWidth: 82,
      minWidth: 82,
      sortable: false,
      filter: false,

      pinned: 'left',
      lockPosition: 'left',
    },
    {
      headerName: 'Template Name',
      field: 'name',
      cellRenderer: (params) => {
        // Handle grouped rows (grouped rows don't need custom rendering)
        if (!params.value || params.node.group) return params.value;
        const updatedData = { ...params.data, type: 'edit' };
        const module = params.data.associatedModule;
        return (
          <Link
            to={`/settings/templateGallery/updateTemplate`}
            state={{ module: module, data: updatedData }}
            style={{ fontWeight: '600' }}
          >
            {params.value}
          </Link>
        );
      },
      filter: 'agSetColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Template Subject',
      field: 'subject',
      filter: 'agSetColumnFilter',

      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Associated Module',
      field: 'associatedModule',

      filter: 'agSetColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Template Type',
      field: 'templateType',
      filter: 'agSetColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Created By',
      field: 'createdBy',
      filter: 'agSetColumnFilter',
      valueFormatter: NameFormatter,
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
  ]);

  const defaultColDef = useMemo(() => ({
    sortable: true,
    editable: false,
    flex: 1,
    minWidth: 130,
    filter: true,
    resizable: true,
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
  }));

  const [viewList, setListView] = useState(true);
  const [viewGallery, setGalleryView] = useState(false);

  const handleListView = () => {
    setListView(true);
    setGalleryView(false);
  };

  const handleGalleryView = () => {
    setGalleryView(true);
    setListView(false);
  };
  const handleClickDelete = (paramsValue) => {
    setLoading(true);
    //const selectedIds = paramsValue.map((user) => user.id);
    const data = {
      id: [paramsValue.id], // Wrap the value in an array
    }; // Creating the desired JSON object
    apiServices
      .deleteTemplate(data)
      .then((response) => {
        if (response?.status === 200) {
          toast.success('Template Deleted Successfully!', {
            position: 'top-right',
          });
          dispatch(
            fetchDataAndUpdateStore({
              key: 'template',
            })
          );
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error('Error deleting record:', error);
        setLoading(false);
      });
  };
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleOpenDeletePopUp = (value) => {
    setShowConfirmation(true);
    setDeleteData(value);
  };
  const handleConfirmDelete = () => {
    console.log('rowData==>', deleteData);
    handleClickDelete(deleteData);
    setShowConfirmation(false);
  };

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
  };
  const statusBar = useMemo(() => {
    return {
      statusPanels: [
        { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' },
        { statusPanel: 'agFilteredRowCountComponent' },
        { statusPanel: 'agSelectedRowCountComponent' },
        { statusPanel: 'agAggregationComponent' },
      ],
    };
  }, []);

  const filteredGroupedData = groupedData
    ?.map((group) => ({
      ...group,
      items: group.items.filter(
        (item) =>
          item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.subject?.toLowerCase().includes(searchTerm.toLowerCase())
      ),
    }))
    .filter((group) => group.items.length > 0); // Only keep groups with matching items

  return (
    <>
      <div className="inner-page" style={containerStyle}>
        <div className="dash-container">
          <div className="tbl_container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12">
                <div className="main-hd">
                  <div className="pagetitle">
                    <img src="../assets/images/role-management-icons/left-arrow.png" alt="" />
                    Templates | Email
                  </div>
                  <div className="third-div tempLinkMain mobView">
                    <div className="heading_item dsk" id="contct_search">
                      <div className="search-container">
                        {viewGallery ? (
                          <input
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="form-control"
                          />
                        ) : (
                          <input
                            className="form-control"
                            id="filter-text-box"
                            type="Text"
                            placeholder="Search..."
                            onInput={onFilterTextBoxChanged}
                          />
                        )}
                        <button className="contactsearch" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <circle cx="11" cy="11" r="8"></circle>
                            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div className="heading_item tempLink">
                      <div className="heading_item">
                        <button
                          className={
                            !viewList
                              ? 'btn btn-outline-primary export-btn'
                              : 'btn btn-outline-primary export-btn btn-sel'
                          }
                          onClick={handleListView}
                        >
                          <i className="bi bi-list-ul"></i>
                          <span className="ms-2 dsk"> List View</span>
                        </button>
                        <button
                          className={
                            !viewGallery
                              ? 'btn btn-outline-primary export-btn'
                              : 'btn btn-outline-primary export-btn btn-sel'
                          }
                          onClick={handleGalleryView}
                        >
                          <i className="bi bi-grid"></i>
                          <span className="ms-2 dsk">Grid View</span>
                        </button>
                      </div>
                      <button
                        className="btn btn-primary newTemplate"
                        onClick={() => templatePopup('all')}
                      >
                        New Template
                      </button>
                    </div>
                  </div>
                </div>
                <div className="mob mb-3">
                  <div className="heading_item" id="contct_search">
                    <div className="search-container">
                      {viewGallery ? (
                        <input
                          type="text"
                          placeholder="Search..."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          className="form-control"
                        />
                      ) : (
                        <input
                          className="form-control"
                          id="filter-text-box"
                          type="Text"
                          placeholder="Search..."
                          onInput={onFilterTextBoxChanged}
                        />
                      )}
                      <button className="contactsearch" type="button">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <circle cx="11" cy="11" r="8"></circle>
                          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="templateContainer">
                  {viewList && (
                    <div className="cutome_ag_theme">
                      {loading && <Loader />}
                      <div
                        className={`ag-theme-${selectedTheme} tbl_height`}
                        style={{ width: '100%', height: `100%` }}
                      >
                        {loading ? (
                          <CustomLoadingOverlay loadingMessage="Loading..." />
                        ) : (
                          <AgGridReact
                            className="ag-grid-container"
                            // className="ag-grid-container-drg" // Add a class for styling
                            domLayout="fixedHeight"
                            ref={gridRef} // Ref for accessing Grid's API
                            rowData={rowData} // Row Data for Row
                            columnDefs={columnDefs}
                            // autoGroupColumnDef={autoGroupColumnDef}
                            defaultColDef={defaultColDef} // Default Column Properties
                            overlayLoadingTemplate={`<Loader />`}
                            animateRows={true} // Optional - set to 'true' to have rows animate when sorted
                            rowSelection={'multiple'} // Options - allows click selection of rows
                            statusBar={statusBar}
                            // sideBar={sideBar} // pass side by making interface
                            enableRangeSelection={true}
                            suppressExcelExport={true}
                            suppressRowClickSelection={true}
                            groupSelectsChildren={true}
                            // pivotPanelShow={'always'}
                            rowDragManaged={true}
                            suppressMoveWhenRowDragging={true}
                            // rowGroupPanelShow={'always'}
                          />
                        )}
                      </div>
                    </div>
                  )}

                  {viewGallery && (
                    <div className="galleryView">
                      {loading && <Loader />}
                      <div className="row">
                        {filteredGroupedData &&
                          filteredGroupedData.length > 0 &&
                          filteredGroupedData.map((temp, index) => (
                            <>
                              <div key={index} className="col-12">
                                <div className="templateTypeHd">
                                  <h2>
                                    {temp.templateType}
                                    <span className="tempNo">{temp.items.length}</span>
                                  </h2>
                                </div>
                                <div className="row">
                                  {temp &&
                                    temp.items.length > 0 &&
                                    temp.items.map((value, i) => (
                                      <div
                                        key={i}
                                        className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 "
                                      >
                                        <div className="galleryText">
                                          <div className="txtDetail">
                                            {value && value.name ? (
                                              <h2>{value.name}</h2>
                                            ) : (
                                              <h2 className="novalue">No Name Available</h2>
                                            )}
                                            {value && value.subject ? (
                                              <p>{value.subject}</p>
                                            ) : (
                                              <h2 className="novalue">No Subject Available</h2>
                                            )}

                                            {value && value.createdBy ? (
                                              <p className="small">
                                                <b>
                                                  <i className="bi bi-person-circle"></i>
                                                </b>
                                                {value.createdBy}
                                              </p>
                                            ) : (
                                              <p className="novalue">NA</p>
                                            )}
                                          </div>
                                          <div className="moduleDisplay">
                                            {value && value.associatedModule ? (
                                              <>{value.associatedModule}</>
                                            ) : (
                                              <>
                                                <span className="novalue">NA</span>
                                              </>
                                            )}

                                            <button
                                              className="btnTrash"
                                              onClick={() => {
                                                handleOpenDeletePopUp(value);
                                              }}
                                            >
                                              <i className="bi bi-trash3"></i>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                </div>
                              </div>
                            </>
                          ))}
                      </div>
                      {showConfirmation && (
                        <DeleteConfirmationModal
                          show={showConfirmation}
                          handleClose={handleCloseConfirmation}
                          handleConfirm={handleConfirmDelete}
                          content={'template'}
                        />
                      )}
                    </div>
                  )}
                </div>
                {showTemplatePopup && (
                  <CreateTemplate
                    handleClose={closeTemplatePopup}
                    templatePageType={templatePageType}
                  />
                )}

                {showEditTemplatePopup && <EditTemplate handleClose={closeEditTemplatePopup} />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Templates;
